module.exports = __webpack_public_path__ + "media/images/country_flags/tk-1b63d337e011b82052124e60f77e195c.png";